import React from 'react'

const play = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4L18 11L6 18V4Z" fill="white"/>
  </svg>
)

export default play
